import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

function PrivateRoute({ children }) {
  const { data: user } = useSelector((state) => state.user);

  if (!user) return <Navigate to="/" />;
  if (user && user?.firstAccess)
    return <Navigate to="/changepassword" />;
  return children;
}

export default React.memo(PrivateRoute);
